import { render } from "./ChangePassword.vue?vue&type=template&id=0c4398d6&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=0c4398d6&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4398d6"]])

export default __exports__